import { $host } from './index';

// Doctor Categories
export const fetchDoctorCategories = async () => {
  const { data } = await $host.get('web/doctor-categories');
  return data;
};

export const fetchOneDoctorCategory = async (id) => {
  const { data } = await $host.get(`web/doctor-categories/${id}`);
  return data;
};

export const createOrUpdateDoctorCategory = async (category) => {
  const { data } = await $host.post('web/doctor-categories', category);
  return data;
};

export const deleteDoctorCategory = async (id) => {
  const { data } = await $host.post('web/doctor-categories/remove', { id });
  return data;
};

export const reorderDoctorCategories = async (categories) => {
  const { data } = await $host.post('web/doctor-categories/reorder', { categories });
  return data;
};

// Service Categories
export const fetchServiceCategories = async () => {
  const { data } = await $host.get('web/service-categories');
  return data;
};

export const fetchOneServiceCategory = async (id) => {
  const { data } = await $host.get(`web/service-categories/${id}`);
  return data;
};

export const createOrUpdateServiceCategory = async (category) => {
  const { data } = await $host.post('web/service-categories', category);
  return data;
};

export const deleteServiceCategory = async (id) => {
  const { data } = await $host.post('web/service-categories/remove', { id });
  return data;
};

export const reorderServiceCategories = async (categories) => {
  const { data } = await $host.post('web/service-categories/reorder', { categories });
  return data;
};

// Chat Categories
export const fetchChatCategories = async () => {
  const { data } = await $host.get('web/chat-categories');
  return data;
};

export const fetchOneChatCategory = async (id) => {
  const { data } = await $host.get(`web/chat-categories/${id}`);
  return data;
};

export const createOrUpdateChatCategory = async (category) => {
  const { data } = await $host.post('web/chat-categories', category);
  return data;
};

export const deleteChatCategory = async (id) => {
  const { data } = await $host.post('web/chat-categories/remove', { id });
  return data;
};

export const transferChatCategoryChats = async (fromCategoryId, toCategoryId) => {
  const { data } = await $host.post('web/chat-categories/transfer', {
    fromCategoryId,
    toCategoryId,
  });
  return data;
};

export const reorderChatCategories = async (categories) => {
  const { data } = await $host.post('web/chat-categories/reorder', { categories });
  return data;
};
